import React, { useReducer, useContext, useEffect } from 'react'
import { lockedReducer } from '../../Utils/reducers'
import { api } from '../../../services/api'
import ColorButton from '../../Buttons/ColorButton';
import DefaultModal from '../../Utils/DefaultModal';
import toast from 'react-hot-toast'
import { Box, Tooltip, TextField } from '@mui/material'
import validateData from './validateData';
import { externalComponent } from '../../AppRoutes';
import MegaAutoComplete from '../../Utils/megautocomplete';

const url = '/colaboradores/'

const submit = async (data, getData, setLoader, handleClose) => {

    setLoader(true)
    let res = null

    if (data.id)
        res = await api.patch(`${url}${data.id}/`, data)
    else
        res = await api.post(url, data)
    if (res.status === 201 || res.status === 200) {
        toast.success(`Colaborador ${res.status === 201 ? 'adicionado' : 'editado'} com sucesso`)
        getData()
        handleClose()
        setLoader(false)
        return
    }
    toast.error(`Colaborador não pôde ser ${!data.id ? 'adicionado' : 'editado.'} Motivo: ${res.data}`)
    setLoader(false)
}

const loadRetrieve = async (id, setState, setLoader) => {
    setLoader(true)
    const res = await api.get(url + `${id}/`)
    if (res.status === 200) {
        setState({ ...res.data})
    }
    setLoader(false)
}

const getTitle = (data) => {
    if (data?.id)
        return 'Editar'
    return 'Adicionar'
}

const EditColaborador = ( {data, handleClose, reloadData} ) => {

    const { setLoader } = useContext(externalComponent)

    const [state, setState] = useReducer(lockedReducer, {
        branch: [],
        phone: '',
        email: '',
        ...data,
        id: data.id ? data.id : 0
    })

    const validData = validateData(state)

    useEffect(() => {
        if (data.id)
            loadRetrieve(data.id, setState, setLoader)
        else
            setState({ loaded: true })
    }, [setLoader, data.id])
    
    return(
        <>
        <DefaultModal
                title={
                    `${getTitle(state)} Colaborador`
                }
                open={true}
                handleClose={handleClose}
                content={
                    <>
                        <Box className='item-content-modal noborder' >
                            <Box className='item-profile-row-informative'>
                                <TextField
                                    id="phone"
                                    type="text"  
                                    label="Telefone"
                                    value={state.phone}
                                    onChange={(e) => { setState({ 'phone': e.target.value }) }}
                                    fullWidth={false}j
                                    size='small'
                                    inputProps={{
                                        maxLength: 50
                                    }}
                                />
                                <p className='informative-text'>Podem ser informados mais de um telefone separados por ponto e vírgula ( ; ).</p>
                            </Box>
                            
                  
                            <Box className='item-profile-row-informative'>
                                <TextField
                                    id="email"
                                    type="text"
                                    label="Email"
                                    size='small'
                                    value={state.email}
                                    onChange={(e) => { setState({ 'email': e.target.value }) }}
                                    fullWidth={false}
                                    inputProps={{
                                        maxLength: 100
                                    }}
                                />
                                <p className='informative-text'>Podem ser informados mais de um email separados por ponto e vírgula ( ; ).</p>
                            </Box>

                            <Box className='item-profile-row'>

                                <MegaAutoComplete
                                    multiple={true}
                                    value={state.branch}
                                    onChange={(data) => setState({ branch : data })}
                                    noOptionsText={'Digite para procurar uma Filial'}
                                    timeoutUrl='/colaboradores/filiais/'
                                    timeoutParam='label'
                                    label='Filial'
                                />

                            </Box>

                          
                        </Box>
                    </>
                }
                action={
                    <>
                        <Tooltip placement="left" title={validData}>
                            <Box>
                                <ColorButton
                                    onClick={() => submit(state, reloadData, setLoader, handleClose)}
                                    disabled={validData}
                                >{getTitle(state)}
                                </ColorButton>
                            </Box>
                        </Tooltip>
                    </>
                }
            />
        </>
    )
}

export default EditColaborador;